import { render, staticRenderFns } from "./TablePartners.vue?vue&type=template&id=2b8c61c6"
import script from "./TablePartners.vue?vue&type=script&lang=js"
export * from "./TablePartners.vue?vue&type=script&lang=js"
import style0 from "./TablePartners.vue?vue&type=style&index=0&id=2b8c61c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports